import { ConfiguredItem } from '../interfaces/configured-item';

// Must match the fee the API charges in ItemsService.Get (RingBuilderAPI), which is what a
// retailer's item is billed at.
export const ENGRAVING_FEE = 6;

export function engravingFeeFor(item: Pick<ConfiguredItem, 'engravingText' | 'engravingType'>): number {
  return item.engravingText && item.engravingType ? ENGRAVING_FEE : 0;
}

export const engravingSpecialChars = [
  {
    haloChar: '{',
    char: '∞',
    unicode: '\\u221e',
    haloCharUnicode: '\\u007B'
  },
  {
    haloChar: '}',
    char: '♡',
    unicode: '\\u2661',
    haloCharUnicode: '\\u007D'
  }
];
